<template>
  <div v-if="tradeType == 'opt'" class="mini-cart__devices" :class="{'mini-cart__devices--cart': blockType == 'cart'}">
    <div class="mini-cart-meal__top">
      <img src="@/assets/img/devices.svg" class="mini-cart-meal__img" />
      <div class="mini-cart-meal__name"> Добавить приборы, <br> салфетки </div>
      <div v-if="!$route.path.includes('cart')" @click="toggleDevices" class="mini-cart-meal__toggler" :class="{ 'mini-cart-meal__toggler--active': hasDevices }" />
      <img @click="clearDevices" src="@/assets/img/close.svg" class="cart-meal-row__remove" alt="Remove" v-if="blockType == 'cart'"/>
    </div>
    <div class="mini-cart-meal__bottom" v-if="hasDevices">
      <div class="mini-cart-meal-row__cost" v-if="!mobileCheck()">
        <Counter
          :value.sync="mealCount"
          :uiColor="tradeType == 'opt' ? 'blue' : 'green'"
          :canChange="true"
          :mini="true" 
          :hasInput="true"
          @change="switchCounter"
        />
        <div class="mini-cart-meal__price-for-one"> {{ getDeviceInfo?.price }} ₽/шт </div>
      </div>
      <Counter
        :value.sync="mealCount"
        :uiColor="tradeType == 'opt' ? 'blue' : 'green'"
        :canChange="true" :mini="true" 
        @change="switchCounter"
        v-if="mobileCheck()"
      />
      <div class="mini-cart-meal__price-for-one" v-if="mobileCheck()"> {{ getDeviceInfo?.price }} ₽/шт </div>
      <div class="mini-cart-meal__rub"> {{ getDeviceInfo?.price * mealCount }} ₽ </div>
      <img @click="clearDevices" src="@/assets/img/close.svg"
        class="cart-meal-row__remove" alt="Remove" v-if="blockType == 'cart'"/>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { mobileCheck } from "@/helpers";

export default {
  computed: {
    ...mapGetters({
      cartMeals: 'getCartMeals',
      getDeviceInfo: 'getDeviceInfo',
    }),
		mealCount() {
			return Number(this.meal.count)
		}
  },
  components: {
    Counter: () => import("@/components/ui/Counter.vue"),
  },
  props: {
    blockType: {
      type: String,
      default: 'miniCart',
    },
		hasDevices: {
			type: Boolean,
			default: true
		},
    tradeType: {
      type: String,
      default: 'rozn',
    },
		meal: {
			type: Object,
			default: () => ({
        count: 0,
      }),
		}
  },
  methods: {
    async toggleDevices() {
      this.$emit('toggleDevices');
		  await this.clearDevices();
    },
    mobileCheck,

    async switchCounter(counter) {
      const count = counter
		  await this.$store.dispatch('addToCart', { id: this.getDeviceInfo?.id, count: count || '', cartId: this.meal.cart_id });
    },

    async clearDevices() {
		  await this.$store.dispatch('addToCart', { id: this.getDeviceInfo?.id, count: 0, cartId: this.meal.cart_id });
    }
  }
}
</script>
<style lang="scss">
.mini-cart-meal__remove-item
{
	height: 24px;
	cursor: pointer;
}

.mini-cart-meal__top
{
	display: flex;
	margin-bottom: 8px;
  flex: 1;

  .cart-meal-row__remove {
    height: 24px;
    display: none;
  }

  @media (max-width: 767px) {
    .cart-meal-row__remove { display: block }
  }
}

.mini-cart-meal__name
{
	width: 100%;
	font-size: 16px;
	line-height: 20px;
	font-family: $mainFontNew;
}

.mini-cart-meal__img
{
	border-radius: 24px;
	object-fit: cover;
	width: 40px;
	height: 40px;
	min-width: 40px;
	margin-right: 12px;

  &--big {
    width: 96px;
    height: 96px;
  }
}

.mini-cart-meal__remove
{
	min-width: 20px;
	cursor: pointer;
}

.mini-cart-meal__bottom
{
	display: flex;
	justify-content: space-between;
	align-items: center;
  flex: 1;
}

.mini-cart-meal__counter
{width: 102px;}

.mini-cart-meal__price-for-one
{
	background-color: $greyBackground;
	border-radius: 2px;
	padding: 4px 6px;
	font-size: 14px;
	line-height: 20px;
	font-family: $mainFontBoldNew;
	color: $textColor;
}

.mini-cart-meal__price
{
	display: flex;
	align-items: center;
	gap: 6px;
}

.mini-cart-meal__rub
{
	font-size: 20px;
	font-family: $mainFontBoldNew;
	letter-spacing: -1px;
}

.mini-cart-meal-row__cost {
  display: flex;
  align-items: center;
  gap: 40px;
}

.mini-cart__devices--cart {
  display: flex;
  justify-content: space-between;

  .mini-cart-meal__img {
    width: 100%;
    height: 100%;
    max-width: 96px;
    max-height: 96px;
    margin-right: 24px;

    @media (max-width: 767px) {
      width: 40px;
      height: 40px;
      min-width: unset;
      margin-right: 12px;
    }
  }

  .mini-cart-meal__bottom {
    align-items: flex-start;
    width: 100%;
    max-width: 370px;
  }

  .mini-cart-meal-row__cost {
    flex-direction: column;
    gap: 8px;
  }

  @media (max-width: 767px) {
    flex-direction: column;

    .mini-cart-meal__name br { display: none }

    .mini-cart-meal__bottom {
      max-width: unset;

      .cart-meal-row__remove { display: none }
    }
  }
}
</style>